<template>
  <Select v-model="selected" @on-select="handleSelect" :clearable="clearable" :placeholder="$t('order.order_type_select_placeholder')">
    <Option v-for="p in orderTypes" :key="p.value" :value="p.value">{{ p.label }}</Option>
  </Select>
</template>

<script>
export default {
  name: 'OrderTypeSelect',
  props: {
    clearable: Boolean
  },
  data () {
    return {
      selected: this.$attrs.value,
      orderTypes: [
        { value: 'pcba', label: 'PCBA' },
        { value: 'turnkey', label: 'Turnkey' },
        { value: 'purchase_components', label: 'Purchase components' },
        { value: 'layout', label: 'Layout' }
      ]
    }
  },
  methods: {
    handleSelect (item) {
      this.$emit('input', item.value)
    }
  }
}
</script>
